(function () {
  "use strict";
  if (window.__escalePromoPopupLoaded) return;
  window.__escalePromoPopupLoaded = true;

  var HOST = window.location.host;
  var SUB_KEY = "escale-popup-subscribed-" + HOST;
  var params = new URLSearchParams(window.location.search);
  var FORCE = params.has("testpopup");

  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  var POSTED = params.get("customer_posted") === "true" && sget("escale-popup-pending") === "1";

  function show(modal, overlay) {
    modal.classList.add("popup-modal--active");
    overlay && overlay.classList.add("popup-overlay--active");
    modal.style.visibility = "visible";
    modal.style.opacity = "1";
    modal.style.zIndex = "2147483000";
    modal.style.transform = "translate(-50%, -50%)";
    if (overlay) {
      overlay.style.zIndex = "2147482999";
      overlay.style.width = "100%";
      overlay.style.height = "100%";
      overlay.style.backgroundColor = "rgba(0,0,0,.35)";
    }
  }
  function hide(modal, overlay) {
    modal.classList.remove("popup-modal--active");
    overlay && overlay.classList.remove("popup-overlay--active");
    ["visibility", "opacity", "zIndex", "transform"].forEach(function (p) { modal.style[p] = ""; });
    if (overlay) ["zIndex", "width", "height", "backgroundColor"].forEach(function (p) { overlay.style[p] = ""; });
  }

  function setup(modal) {
    var root = modal.closest(".shopify-section") || modal.parentNode;
    var overlay = root.querySelector(".sign-up-popup-overlay");
    var success = root.querySelector(".success-popup-modal");
    var successOverlay = root.querySelector(".success-popup-overlay");
    var sectionId = modal.getAttribute("data-section-id") || "popup";
    var storageKey = "escale-popup-" + HOST + "-" + sectionId;
    var testMode = modal.getAttribute("data-test-mode") === "true";
    var delay = parseInt(modal.getAttribute("data-delay-seconds"), 10);
    var days = parseInt(modal.getAttribute("data-delay-days"), 10) || 30;
    if (isNaN(delay)) delay = 10;
    if (FORCE) delay = 2;

    function closeMain() {
      hide(modal, overlay);
      if (!testMode && !FORCE) set(storageKey, String(Date.now() + days * 86400000));
    }
    function closeSuccess() { if (success) hide(success, successOverlay); }

    modal.querySelectorAll(".popup-modal__close, .popup-modal__dismiss-btn").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); closeMain(); });
    });
    overlay && overlay.addEventListener("click", closeMain);
    if (success) {
      success.querySelectorAll(".popup-modal__close, .popup-modal__dismiss-btn").forEach(function (b) {
        b.addEventListener("click", function (e) { e.preventDefault(); closeSuccess(); });
      });
      successOverlay && successOverlay.addEventListener("click", closeSuccess);
      var copyBtn = success.querySelector(".popup-modal__copy-btn");
      var codeInput = success.querySelector("input[readonly]");
      var copyMsg = success.querySelector(".popup-modal__success-msg");
      copyBtn && copyBtn.addEventListener("click", function (e) {
        e.preventDefault();
        if (!codeInput) return;
        var done = function () { if (copyMsg) { copyMsg.style.display = "block"; setTimeout(function () { copyMsg.style.display = "none"; }, 3000); } };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codeInput.value).then(done, function () { codeInput.select(); try { document.execCommand("copy"); } catch (x) {} done(); });
        } else { codeInput.select(); try { document.execCommand("copy"); } catch (x) {} done(); }
      });
    }

    var form = modal.querySelector("form");
    if (form) {
      form.addEventListener("submit", function () {
        sset("escale-popup-pending", "1");
      });
    }

    var hasError = !!modal.querySelector(".newsletter-form__message");

    if (POSTED) {
      sset("escale-popup-pending", "");
      set(SUB_KEY, "1");
      if (success) show(success, successOverlay);
      return;
    }
    if (hasError && sget("escale-popup-pending") === "1") {
      sset("escale-popup-pending", "");
      show(modal, overlay);
      return;
    }

    if (!FORCE && !testMode) {
      if (get(SUB_KEY)) return;
      var until = parseInt(get(storageKey), 10);
      if (until && until > Date.now()) return;
    }
    setTimeout(function () { show(modal, overlay); }, delay * 1000);
  }

  function boot() {
    document.querySelectorAll(".sign-up-popup-modal").forEach(function (m) {
      try { setup(m); } catch (err) { if (window.console) console.error("[EscalePopup]", err); }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
